/* eslint-disable import/named */
import { PayloadAction } from '@reduxjs/toolkit';
import { getAuthorization } from 'api/AuthApi';
import { ERROR_SERVER } from 'constant/textNotification';
import { ACCESS_TOKEN } from 'constant/token';
import { appAction } from 'reducers/app/action';
import { call, put, takeLatest } from 'redux-saga/effects';
import { LoginDataType } from 'types/authType';
import { decodeJwt, FunctionGroupName } from 'utils/helperFunctions';
import { authAction } from './action';
import { IRoleDetail, IRoleUserGroup } from './model';
import { getLocalStorage } from 'utils/browserStorageUtil';

function* implementSetUserAuthorization() {
  try {
    let questionBankRoles: IRoleUserGroup[] = [];
    let userRoles: IRoleUserGroup[] = [];
    let userGroupsRoles: IRoleUserGroup[] = [];
    let surveyRoles: IRoleUserGroup[] = [];

    const infoUser = getLocalStorage('infoUser');
    if (!infoUser) {
      yield put(authAction.setIsLoading(false));
      return;
    }
    const userInfoParse = JSON.parse(infoUser);
    if (!userInfoParse || !userInfoParse?.userID) {
      yield put(authAction.setIsLoading(false));
      return;
    }

    yield put(authAction.setIsLoading(true));

    const userAuthorization: IRoleDetail[] = yield call(getAuthorization, userInfoParse?.userID);
    if (!Array.isArray(userAuthorization)) {
      yield put(authAction.setIsLoading(false));
      return;
    }
    const response = [...userAuthorization];

    response.forEach((f) => {
      switch (f.functionGroupName) {
        case FunctionGroupName.MANAGE_USERS:
          userRoles = f.userGroupFunctions;
          break;
        case FunctionGroupName.MANAGE_USER_GROUPS:
          userGroupsRoles = f.userGroupFunctions;
          break;
        case FunctionGroupName.QUESTION_BANK:
          questionBankRoles = f.userGroupFunctions;
          break;
        case FunctionGroupName.SURVEYS:
          surveyRoles = f.userGroupFunctions;
          break;
        default:
          break;
        // Do nothing
      }
    });
    yield put(authAction.setQuestionBankAuthorization(questionBankRoles));
    yield put(authAction.setUserAuthorization(userRoles));
    yield put(authAction.setUserGroupAuthorization(userGroupsRoles));
    yield put(authAction.setSurveyAuthorization(surveyRoles));
    yield put(authAction.setIsLoading(false));
  } catch (error) {
    yield put(authAction.setIsLoading(false));
  } finally {
    yield put(appAction.setAppLoading(false));
  }
}

function* implementSetUserInfo(action: PayloadAction<LoginDataType>) {
  const data = action.payload;
  yield put(appAction.setAppLoading(true));
  yield put(authAction.setLoginData(data));
  yield put(authAction.setIsAuth(true));
}

function* authSaga() {
  yield takeLatest(authAction.takeLoginData.type, implementSetUserInfo);
  yield takeLatest(authAction.takeAuthorization.type, implementSetUserAuthorization);
}

export default authSaga;
